export default __webpack_public_path__ + "static/heroSectionImg-bed08414f72509f2f9e3145925d7d921.webp";